import { AxiosError } from "axios";

export default function ReturnsNullOn404(): MethodDecorator {
    return function (target: object, key: string | symbol, descriptor: PropertyDescriptor | undefined) {
        if (descriptor === undefined) {
            descriptor = Object.getOwnPropertyDescriptor(target, key);
        }
        if (descriptor === undefined) {
            throw new Error(`target has no descriptor for key "${String(key)}"`)
        }
        const originalMethod: (...args: unknown[]) => Promise<unknown> = descriptor.value;


        descriptor.value = function (...args: unknown[]) {
            return Reflect.apply(originalMethod, this, args)
                .catch(function (error: unknown): null {
                    if (error instanceof AxiosError) {
                        const response = error.response;

                        if (response?.status === 404) {
                            return null;
                        }

                    }
                    throw error;
                });
        }
    }
}